import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { staffApi, errMsg } from "@/lib/api";

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ current_password: "", new_password: "" });

  const save = async (e) => {
    e.preventDefault();
    try { const { data } = await staffApi().post("/auth/change-password", f); sessionStorage.setItem("vp_token", data.token); toast.success("Password changed"); setOpen(false); setF({ current_password: "", new_password: "" }); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" data-testid="change-password-button"><KeyRound className="h-4 w-4 sm:mr-1" /><span className="hidden sm:inline">Password</span></Button>
      </DialogTrigger>
      <DialogContent className="rounded-3xl bg-white sm:max-w-sm" data-testid="change-password-dialog">
        <DialogHeader><DialogTitle>Change your password</DialogTitle><DialogDescription>Use at least 8 characters.</DialogDescription></DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <Input type="password" placeholder="Current password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="current-password-input" />
          <Input type="password" placeholder="New password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="new-password-input" />
          <Button type="submit" className="w-full rounded-full bg-[#0A3A6B] hover:bg-[#1D64B4]" data-testid="change-password-save">Save</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
